"use strict";
exports.__esModule = true;
exports["default"] = (function (ctx, options) {
    ctx.textAlign = "right";
    ctx.fillText(options.content, ctx.canvas.width - 20, ctx.canvas.height - 20);
});
